import React from 'react';
import SimBuilderVariableListItem from './SimBuilderVariableListItem';
import useExpandCollapse from '../../hooks/useExpandCollapse';

const VariableListWrapper = ({
  title,
  variables,
  emptyMessage,
  handleVariableSelect,
  handleVariableDelete,
  selectedVariableId,
}) => {
  const [isExpanded, expandMarkup] = useExpandCollapse({
    vertical: false,
  });

  return (
    <div>
      <div
        className="py-2 bg-gray-50 border-b border-gray-200"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative',
          paddingRight: '12px',
          paddingLeft: '12px',
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: '0.875rem',
            fontWeight: 600,
            color: '#374151',
            letterSpacing: '0.05em',
            paddingRight: '40px',
          }}
        >
          {title} ({variables.length})
        </h3>
        {expandMarkup}
      </div>
      {isExpanded &&
        (variables.length > 0 ? (
          variables.map((v) => {
            return (
              <SimBuilderVariableListItem
                key={v.id}
                {...v}
                handleVariableSelect={handleVariableSelect}
                handleVariableDelete={handleVariableDelete}
                selectedVariableId={selectedVariableId}
              />
            );
          })
        ) : (
          <div
            className="text-center py-4"
            style={{ color: '#9CA3AF', fontSize: '0.875rem' }}
          >
            {emptyMessage}
          </div>
        ))}
    </div>
  );
};

export default VariableListWrapper;